export const getActiveStyles = (editorState: any) => {
  const selection = editorState.getSelection();
  const activeStyles = {
    weights: [] as string[],  // Explicitly define weights as a string array
    colors: [] as string[],   // Explicitly define colors as a string array
  };

  if (!selection.isCollapsed()) {
    const contentState = editorState.getCurrentContent();
    const startKey = selection.getStartKey();
    const startOffset = selection.getStartOffset();
    const endOffset = selection.getEndOffset();

    let colorStyles: string[] = [];
    let weightStyles: string[] = [];

    for (let i = startOffset; i < endOffset; i++) {
      const inlineStyles = contentState.getBlockForKey(startKey).getInlineStyleAt(i);

      inlineStyles.forEach((style: string | undefined) => {
        if (style) {
          // Check for weight styles
          if (["default", "regular", "bold", "light"].includes(style)) {
            weightStyles.push(style);
          } else {
            // Otherwise, add to color styles
            colorStyles.push(style);
          }
        }
      });
      console.log(inlineStyles)
    }


    // Deduplicate arrays and assign
    const deduplicateArray = (array: string[]) => Array.from(new Set(array));
    activeStyles.weights = deduplicateArray(weightStyles);
    activeStyles.colors = deduplicateArray(colorStyles);
  }

  return activeStyles;
};
